import React from "react";
import {
  MdFullscreen,
  MdFullscreenExit,
  MdPrint,
  MdDownload,
  MdZoomIn,
  MdZoomOut,
  MdUploadFile,
} from "react-icons/md";
import { CSS_CLASSES, ZOOM_CONFIG } from "../FilePreviewer.config";
import { ToolbarProps } from "./Toolbar.types";

/**
 * Toolbar component for FilePreviewer
 * Contains all action buttons and title display
 */
const Toolbar: React.FC<ToolbarProps> = ({
  blobUrl,
  enableDownload,
  enableFullscreen,
  enablePrint,
  enableUpload,
  enableZoom,
  fileError,
  fileLoading,
  fileUrl,
  title,
  zoomLevel,
  isFullscreen,
  onDownload,
  onPrint,
  onToggleFullscreen,
  onUploadClick,
  onZoomIn,
  onZoomOut,
}) => {
  // Don't render toolbar if no features are enabled
  const shouldShowToolbar =
    title ||
    enableDownload ||
    enablePrint ||
    enableFullscreen ||
    enableZoom ||
    enableUpload;

  if (!shouldShowToolbar) {
    return null;
  }

  return (
    <div className={CSS_CLASSES.BUTTONS}>
      {title && <div className={CSS_CLASSES.TITLE}>{title}</div>}
      <div className={CSS_CLASSES.BUTTON_GROUP}>
        {enableZoom && (
          <>
            {" "}
            <button
              className={CSS_CLASSES.ICON_BUTTON}
              onClick={onZoomOut}
              disabled={
                fileLoading || !!fileError || zoomLevel <= ZOOM_CONFIG.MIN
              }
              title="Zoom Out"
            >
              {MdZoomOut({ size: 20 })}
            </button>
            <button
              className={CSS_CLASSES.ICON_BUTTON}
              onClick={onZoomIn}
              disabled={
                fileLoading || !!fileError || zoomLevel >= ZOOM_CONFIG.MAX
              }
              title="Zoom In"
            >
              {MdZoomIn({ size: 20 })}
            </button>
          </>
        )}{" "}
        {enableUpload && (
          <button
            className={CSS_CLASSES.ICON_BUTTON}
            onClick={onUploadClick}
            disabled={fileLoading}
            title="Upload New File"
          >
            {MdUploadFile({ size: 20 })}
          </button>
        )}{" "}
        {enableDownload && (
          <button
            className={CSS_CLASSES.ICON_BUTTON}
            onClick={() => onDownload(fileUrl)}
            disabled={fileLoading || !!fileError}
            title="Download"
          >
            {MdDownload({ size: 20 })}
          </button>
        )}
        {enablePrint && (
          <button
            className={CSS_CLASSES.ICON_BUTTON}
            onClick={onPrint}
            disabled={fileLoading || !blobUrl}
            title="Print"
          >
            {MdPrint({ size: 20 })}
          </button>
        )}
        {enableFullscreen && (
          <button
            className={CSS_CLASSES.ICON_BUTTON}
            onClick={onToggleFullscreen}
            disabled={fileLoading}
            title={isFullscreen ? "Exit Fullscreen" : "Fullscreen"}
          >
            {isFullscreen
              ? MdFullscreenExit({ size: 20 })
              : MdFullscreen({ size: 20 })}
          </button>
        )}
      </div>
    </div>
  );
};

export default Toolbar;
